import throttle from 'lodash/throttle';

import { COIN_SWITCH_DELAY } from '../config/constants';
import { analytics } from '../services/analytics';
import soundEffects from '../services/sounds/soundEffects';
import { useStores } from '../stores/useStores';
import { devLog } from '../utils/log';

export function useToggleCoin() {
  const { coinTypeStore, uiStore } = useStores();

  const toggleCoin = throttle(() => {
    if (uiStore.CoinsAnimationVisible) {
      devLog('Coins animation is visible, skipping coin switch');
      return;
    }

    void analytics.sendEvent('lobby_switch', {
      event: 'click',
      current_coin_type: coinTypeStore.coinType,
    });

    const newCoinType = coinTypeStore.coinType === 'GC' ? 'SC' : 'GC';
    coinTypeStore.setCoinType(newCoinType);
    soundEffects.playSound('toggle');
  }, COIN_SWITCH_DELAY);

  return {
    toggleCoin,
  };
}
